module.exports = __webpack_public_path__ + "static/media/bear_2.80b0aa46.jpg";